export const handleChangeInstallmentsUploadFactorPage = (name, value) => ({
    type: 'CHANGE_INSTALLMENTS_UPLOAD_FACTOR_PAGE', name, value
});
